import featureBlacklistExperiments from 'bundles/epic/clients/featureBlacklist';

// https://tools.coursera.org/epic/experiment/OBkBsBBMEeWn7q_gIvwNTw
export const isForumsBlacklisted = (courseId: string) => {
  if (!courseId) {
    throw new Error('isForumsBlacklisted requires a courseId argument');
  }
  const courseIds: Array<string> = featureBlacklistExperiments.get('discussions') || [];
  return courseIds.includes(courseId);
};
